import * as React from 'react';
import { AutoComplete, ListItemProps } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: AccountSearchResult) => void;
    facilityId?: number;
    className?: string;
    style?: {};
};

type State = {
    value: string;
    loading: boolean;
    opened: boolean;
    accountResults: AccountSearchResult[];
}

export interface AccountSearchResult {
    AccountId: number;
    Name: string;
}

export default class AccountAutoComplete extends React.Component<Props, State> {

    private timeout!: NodeJS.Timeout;

    constructor(props: Props) {
        super(props);

        this.state = {
            value: '',
            loading: false,
            opened: false,
            accountResults: [],
        };
    }

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px", fontFamily: "Arial, Helvetica, sans-serif", whiteSpace: "nowrap", overflow: "hidden" }}>{itemProps.dataItem.Name}</span>;

        return React.cloneElement(li, li.props, itemChildren);
    }

    onChange = (event: any) => {
        const eventType = event.nativeEvent.type;
        const valueSelected = eventType === 'click' ||
            (eventType === 'keydown' && event.nativeEvent.keyCode === 13);

        if (valueSelected) {
            let data: AccountSearchResult = event.target.value;
            this.props.callbackFromParent(data);
            this.setState({
                value: data.Name
            });
        } else {
            if (event.target.value.trim().length > 0) {
                clearTimeout(this.timeout);

                this.setState({
                    value: event.target.value,
                    loading: true
                });

                this.timeout = setTimeout(() => {
                    this.filterData(event.target.value);
                }, 500);

            } else {
                this.setState({
                    value: event.target.value,
                    loading: false
                });
            }
        }
    }

    filterData(value: string) {
        const requestData = {
            FacilityID: this.props.facilityId,
            SearchTerm: value,
            //FacilityID: localStorage.getItem("FACILITY_ID") //needs to be passed
        }
        fetchApi('/api/Account/AccountSearch', requestData, 'POST')
            .then((results: AccountSearchResult[]) => {
                this.setState({ accountResults: results, loading: false });
            });
    }

    public render() {
        return (
            <AutoComplete
                data={this.state.accountResults}
                value={this.state.value}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                itemRender={this.itemRender}
                className={this.props.className}
                placeholder= "Account"
            />
        );
    }
}
